import React, { useContext, useEffect } from "react";
// import { GoogleLogin } from "@react-oauth/google";
// import { jwtDecode } from "jwt-decode";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { FiUser } from "react-icons/fi";
import useAuthService from "../../services/Auth";
// import { AuthProvider } from '../../contexts/AuthContext';
import { AuthContext } from "../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineGoogle } from "react-icons/ai";
import { showToast } from "../../services/toastService";

function Login() {
  const { loading, error, get, post } = useAuthService(); // Initialize the custom hook
  // const { isAuthenticated, login, logout } = useAuth();
  const { isAuthenticated, setIsAuthenticated ,userData, setUserData} = useContext(AuthContext);
  const navigate = useNavigate();
  // const usersBaseURL = process.env.USER_API_URL;
  // console.log(usersBaseURL)

  const notifySuccess = (message) => {
    showToast(message, "dark");
  };

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     navigate("/profile")
  //   }
  // }, []);

  const handleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${response.access_token}`,
            },
          }
        );
        const name = res.data.name;
        const email = res.data.email;
        const picture = res.data.picture;
        const cart = []
        const wishlist = []
        const myOrders = []
        
        const postData = { name: name, email: email ,profilePic:picture,cart:cart,wishlist:wishlist,myOrders:myOrders};

        const userExists = await checkUserExists(email);
        if (userExists) {
          setIsAuthenticated(true);
          notifySuccess('Login Successfull')
          navigate("/profile");
          // Redirect to home page if previous location is not available
        } else {
          await fetchData(postData);
        }
      } catch (err) {
        console.log(err);
      }
    },
  });

  const fetchData = async (postData) => {
    try {
      // const response = await post("http://localhost:3001/users", postData);
      const response = await post("https://ecommerce-user-api.onrender.com/users", postData);
      // const response = await post(usersBaseURL, postData);
      // console.log("Data:", response, isAuthenticated);
      navigate("/profile");
       // Redirect to home page if previous location is not available
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const checkUserExists = async (email) => {
    try {
      const response = await axios.get(
        // `http://localhost:3001/users`
        `https://ecommerce-user-api.onrender.com/users`
        // `${usersBaseURL}`
      );
      if (response.data.length > 0) {
        const user = response.data.find((user) => user.email === email);
        if (user) {
          setUserData(user)
          return user;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error checking user existence:", error);
      return false;
    }
  };

  return (
    <div className="" onClick={() => handleLogin()}>
      <AiOutlineGoogle className="text-2xl text-iconcolor hover:text-blue-500 cursor-pointer" />
    </div>
  );
}

export default Login;
